module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "personal-center-form__section"
  }, [_c('h1', {
    staticClass: "personal-center-form__title"
  }, [_vm._v("资料附件上传")]), _vm._v(" "), _c('div', {
    staticClass: "personal-center-form__main"
  }, [_vm._l((_vm.fileTypeList), function(item, index) {
    return _c('div', {
      staticClass: "personal-center-form__file-list file-list",
      on: {
        "mouseenter": function($event) {
          return _vm.changeFileTye(item.fileId)
        }
      }
    }, [_c('h6', {
      staticClass: "file-list__item-title"
    }, [_c('span', [_vm._v(_vm._s(("" + (item.fileName) + (item.customerFileIsMustUpload === '1' ? '（必传）' : ''))))])]), _vm._v(" "), _c('div', {
      staticClass: "file-list__item-content"
    }, [_c('ul', {
      staticClass: "file-list__item-list"
    }, [_vm._l((_vm.fileList[index].files), function(file) {
      return [(['pdf', 'rar', 'zip', '7z', 'PFD', 'RAR', 'ZIP', '7Z'].indexOf(_vm.getFileNameSuffix(file.fileName)) !== -1) ? _c('li', {
        class: ['file-list__item-preview', ("file-list__" + (_vm.getFileNameSuffix(file.fileName)) + "-preview")],
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.showPreviewImage(file.fileId, false)
          }
        }
      }, [(!file.hasSaved) ? _c('div', {
        staticClass: "file-list__item-delete",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.deleteUploadedFile(item.fileId, file)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-close"
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "file-list__file-name"
      }, [_vm._v(_vm._s(file.fileName))])]) : _c('li', {
        staticClass: "file-list__item-preview"
      }, [(file.base64URL) ? _c('img', {
        attrs: {
          "src": file.base64URL
        },
        on: {
          "click": function($event) {
            return _vm.showPreviewImage(file.base64URL, true, true)
          }
        }
      }) : _c('img', {
        attrs: {
          "src": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=" + (file.fileId) + "&tokenId=" + (_vm.userInfo.token))
        },
        on: {
          "click": function($event) {
            return _vm.showPreviewImage(file.fileId, true)
          }
        }
      }), _vm._v(" "), (!file.hasSaved) ? _c('div', {
        staticClass: "file-list__item-delete",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.deleteUploadedFile(item.fileId, file)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-close"
      })]) : _vm._e()])]
    }), _vm._v(" "), (!_vm.isIE9) ? _c('li', {
      staticClass: "file-list__select-file",
      attrs: {
        "slot": "trigger"
      },
      slot: "trigger"
    }, [_c('el-upload', {
      attrs: {
        "action": (_vm.ajaxBaseUrl + "/mobile/crmCustomerAttachInfoController/saveFile.ht"),
        "data": {
          fileTypeId: item.fileId
        },
        "multiple": true,
        "accept": _vm.acceptFileTypes.join(','),
        "headers": {
          tokenId: _vm.userInfo.token
        },
        "show-file-list": false,
        "auto-upload": true,
        "before-upload": _vm.verifyFile,
        "on-success": _vm.uploadDone,
        "on-error": _vm.uploadFail
      },
      nativeOn: {
        "click": function($event) {
          return _vm.test()
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-plus"
    }), _vm._v(" "), _c('div', {
      staticClass: "file-list__select-file-title"
    }, [_vm._v(_vm._s(item.fileName))])])], 1) : _c('li', {
      staticClass: "file-list__select-file picker"
    }, [_c('i', {
      staticClass: "el-icon-plus"
    }), _vm._v(" "), _c('div', {
      staticClass: "file-list__select-file-title"
    }, [_vm._v(_vm._s(item.fileName))])])], 2)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('el-button', {
    staticClass: "personal-center-form__submit",
    attrs: {
      "type": "primary",
      "loading": _vm.isSaving
    },
    on: {
      "click": _vm.saveUploadedFile
    }
  }, [_vm._v("提交")])], 1)], 2)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "file-preview-modal",
    attrs: {
      "title": "图片预览",
      "visible": _vm.filePreview.show,
      "before-close": _vm.hidePreviewImage,
      "close-on-click-modal": false
    }
  }, [_c('div', {
    staticClass: "file-preview-modal__body"
  }, [_c('img', {
    attrs: {
      "src": _vm.filePreview.src,
      "alt": "图片预览"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog__footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "dialog__footer__confirm-btn",
    on: {
      "click": _vm.hidePreviewImage
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5366884"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personalCenter/FileUploading.vue
// module id = 1097
// module chunks = 1